<div *ngIf="!localService.isInternetAvailable" id="offline">
  <div style="margin-top:10%;">
    <div>
      <i style="font-size:70px;color:gray;" class="material-icons">signal_wifi_off</i>
    </div>
    <br />
    <div class="message" [ngClass]="localService.languageContent && localService.languageContent.common ? localService.selectedLanguageCode : 'en'">
      {{localService.languageContent && localService.languageContent.common ? localService.languageContent.common.no_internet : 'No internet is available! Please check your internet connection and try again! This message will be closed automatically once internet is back!'}}
    </div>
  </div>
</div>
